import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { contentLoadingChange } from "../../../../Reducer/componentSlice";
import Handler from "../../../../Helpers/Handler";
import { useAuth } from "../../../../Contexts/AuthenticateProvider";

// Ported from the uploaded reference ThirdDocument.js (the PAN stage) - single
// PAN number field, design unchanged. Wired to
// PATCH /staff/client/associate/kyc/pan/:Id and gated by associate.edit.
const ThirdDocument = ({ associateDetails, onVerified }) => {
    const dispatch = useDispatch();
    const { hasPermission } = useAuth();
    const canSubmit = hasPermission("associate.edit");
    const [loading, setLoading] = useState(false);
    const [pan, setPan] = useState("");

    const panSubmit = async () => {
        if (!canSubmit) return toast.error("You don't have permission to edit this associate");
        if (!pan) return toast.error("Enter Pan No.");
        setLoading(true);
        dispatch(contentLoadingChange(true));
        const response = await Handler({ method: "patch", url: `/staff/client/associate/kyc/pan/${associateDetails?.associateId}`, data: { panNo: pan?.toUpperCase() } });
        dispatch(contentLoadingChange(false));
        if (response?.success) {
            toast.success(response?.data?.message || "Pan Number submitted successfully");
            setTimeout(() => { setLoading(false); onVerified?.(); }, 1200);
        } else {
            setLoading(false);
            toast.error(response?.data?.message || "Submission failed");
        }
    };

    useEffect(() => { setPan(""); }, [associateDetails]);

    return (
        <React.Fragment>
            {!canSubmit ? (
                <div className="alert alert-warning small mb-3">
                    You don't have permission to edit this associate's PAN verification.
                </div>
            ) : null}
            <div className="mb-3">
                <label className="form-label">Pan No</label>
                <input type="text" className="form-control" autoComplete="off" disabled={loading || !canSubmit} value={pan || ""} onChange={(e) => setPan(e.target.value.toUpperCase())} placeholder="Enter Pan Number" />
            </div>
            <div className="mb-3 text-center">
                <button className="btn btn-primary" onClick={panSubmit} disabled={loading || !canSubmit}>{loading ? "Submitting..." : "Submit"}</button>
            </div>
        </React.Fragment>
    );
};

export default ThirdDocument;
